import React, { useState } from "react";
import { Link, useNavigate } from "react-router-dom";

const Sidebar = () => {
  const navigate = useNavigate();
  const [region, setRegion] = useState("");

  const regiones = [
    "lima",
    "arequipa",
    "cusco",
    "puno",
    "junin",
    "huanuco",
    "ica",
    "lambayeque",
    "ucayali",
    "san_martin",
    "pasco",
    "huancavelica",
    "piura",
    "amazonas",
    "madre_de_dios",
    "tacna",
    "moquegua",
    "apurimac",
    "loreto",
    "cajamarca",
    "ancash",
    "la_libertad",
    "tumbes",
    "ayacucho",
    "callao"
  ];

  const handleChange = (e) => {
    const selectedRegion = e.target.value;
    setRegion(selectedRegion);
    if (selectedRegion) {
      navigate(`/catalogo/${selectedRegion}`);
    }
  };

  return (
    <div className="bg-gray-800 md:w-2/5 xl:w-1/5 px-5 py-10">
      {/* Encabezado principal */}
      <h1 className="text-white text-2xl font-bold mb-6">Gestión Panadería</h1>

      <nav className="mt-5 list-none">
        {/* Pedidos */}
        

        {/* Encabezado Catálogos con emoji */}
        <li className="mb-2 text-gray-400 uppercase text-sm">📚 Catálogos</li>

        {/* Selector de regiones */}
        <li className="mb-4">
          <select
            value={region}
            onChange={handleChange}
            className="w-full px-3 py-2 rounded bg-gray-700 text-white"
          >
            <option value="">Selecciona una región</option>
            {regiones.map((r) => (
              <option key={r} value={r}>
                {r.charAt(0).toUpperCase() + r.slice(1)}
              </option>
            ))}
          </select>
        </li>
        <li className="mb-4">
          <button
            onClick={() => navigate("/")}
            className="block px-4 py-2 hover:bg-gray-200 rounded"
          >
            📦 Pedidos
          </button>
        </li>
        <Link
          to="/listado-clientes"
          className="block px-4 py-2 hover:bg-gray-200 rounded"
        >🧑🏻‍🤝‍🧑🏻​ Clientes
        </Link>
        <li><Link to="/ventas"
             className="block px-4 py-2 hover:bg-gray-200 rounded"
        >💹 Ventas Realizadas</Link>
        </li> {/* 👈 Nueva opción */}
        <Link
          to="/pagos"
          className="block px-4 py-2 hover:bg-gray-200 rounded"
        >​💰 Pagos
        </Link>
        <Link
          to="/login"
          className="block px-4 py-2 hover:bg-gray-200 rounded"
        >​💰 Session
        </Link>
        

        {/* Agregar Categoría */}
        <li className="mt-4">
          <button
            onClick={() => navigate("/agregar-categoria")}
            className="hover:bg-gray-700 px-3 py-2 rounded bg-green-600 w-full text-white"
          >
            ➕ Agregar Categoría
          </button>
        </li>
      </nav>
    </div>
  );
};

export default Sidebar;


